<svg [attr.viewBox]="`0 0 ${getWidth()} 30`" [attr.width]="getWidth() + 'px'" height="30px" preserveAspectRatio="none" class="metrics style-plane">
	@for (metric of metrics(); let i = $index; track i) {
		<g [appTooltip]="metric.tooltip" tooltipClass="first-line-bold" (click)="metric.clickHandler?.()" [class.clickable]="metric.clickHandler">
			<!-- Doorzichtige rechthoek voor de hele tooltip/hover area -->
			<rect
				class="metrics-tooltip-area"
				[attr.x]="paddingLeft() + (i + rectPadding()) * barWidth()"
				[attr.y]="0"
				[attr.width]="rectWidth() * barWidth()"
				[attr.height]="30"
				fill="transparent"
				pointer-events="all"
			></rect>
			<rect
				class="metrics-background"
				[attr.x]="paddingLeft() + (i + rectPadding()) * barWidth()"
				[attr.y]="0"
				[attr.width]="rectWidth() * barWidth()"
				[attr.height]="10"
				[attr.rx]="5"
				[attr.ry]="5"
			></rect>
			@if (metric.percentage !== null) {
				<rect
					class="metrics-fill"
					[attr.x]="paddingLeft() + (i + rectPadding()) * barWidth()"
					[attr.y]="0"
					[attr.width]="metric.percentage * (rectWidth() * barWidth())"
					[attr.height]="10"
					[attr.rx]="5"
					[attr.ry]="5"
				></rect>
				<text
					[attr.x]="paddingLeft() + (i + rectPadding()) * barWidth()"
					[attr.y]="14"
					text-anchor="start"
					dominant-baseline="hanging"
					class="metrics-label"
				>
					{{ metric.percentage * 100 | number: "1.0-0" }} %
				</text>
			}
		</g>
	}
</svg>
